// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"58a0469e","245":"1386a0ae"}[chunkId] + ".chunk.js";
};